import React from 'react';

const colorMap = {
  blue:   { bg: 'bg-purple-50',   icon: 'bg-purple-600',   text: 'text-purple-600' },
  green:  { bg: 'bg-green-50',  icon: 'bg-green-600',  text: 'text-green-600' },
  yellow: { bg: 'bg-amber-50',  icon: 'bg-amber-500',  text: 'text-amber-600' },
  red:    { bg: 'bg-red-50',    icon: 'bg-red-600',    text: 'text-red-600' },
  purple: { bg: 'bg-purple-50', icon: 'bg-purple-600', text: 'text-purple-600' },
};

const Card = ({ title, value, icon: Icon, color = 'blue', subtitle }) => {
  const c = colorMap[color] || colorMap.blue;

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-card p-5 flex items-center gap-4">
      {Icon && (
        <div className={`${c.icon} w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0`}>
          <Icon className="text-white" size={20} />
        </div>
      )}
      <div className="min-w-0">
        <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-0.5">{title}</p>
        <p className="text-2xl font-bold text-gray-900 leading-tight">{value}</p>
        {subtitle && <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>}
      </div>
    </div>
  );
};

export default Card;
